import Error from "./ErrorState";

export default Error;